import { stateSelector } from "../../../util/element-internals";
/**
 * Selector for the `active` state.
 * @public
 */
export const activeState = stateSelector("active");
/**
 * Selector for the `align-end` state.
 * @public
 */
export const alignEndState = stateSelector("align-end");
/**
 * Selector for the `align-start` state.
 * @public
 */
export const alignStartState = stateSelector("align-start");
/**
 * Selector for the `anchor` state.
 * @public
 */
export const anchorState = stateSelector("anchor");
/**
 * Selector for the `auto-resize` state.
 * @public
 */
export const autoResizeState = stateSelector("auto-resize");
/**
 * Selector for the `bad-input` state.
 * @public
 */
export const badInputState = stateSelector("bad-input");
/**
 * Selector for the `beige` state.
 * @public
 */
export const beigeState = stateSelector("beige");
/**
 * Selector for the `block` state.
 * @public
 */
export const blockState = stateSelector("block");
/**
 * Selector for the `blue` state.
 * @public
 */
export const blueState = stateSelector("blue");
/**
 * Selector for the `bold` state.
 * @public
 */
export const boldState = stateSelector("bold");
/**
 * Selector for the `bordered` state.
 * @public
 */
export const borderedState = stateSelector("bordered");
/**
 * Selector for the `brand` state.
 * @public
 */
export const brandState = stateSelector("brand");
/**
 * Selector for the `brass` state.
 * @public
 */
export const brassState = stateSelector("brass");
/**
 * Selector for the `brown` state.
 * @public
 */
export const brownState = stateSelector("brown");
/**
 * Selector for the `center` state.
 * @public
 */
export const centerState = stateSelector("center");
/**
 * Selector for the `checked` state.
 * @public
 */
export const checkedState = stateSelector("checked");
/**
 * Selector for the `circular` state.
 * @public
 */
export const circularState = stateSelector("circular");
/**
 * Selector for the `cornflower` state.
 * @public
 */
export const cornflowerState = stateSelector("cornflower");
/**
 * Selector for the `cranberry` state.
 * @public
 */
export const cranberryState = stateSelector("cranberry");
/**
 * Selector for the `custom-error` state.
 * @public
 */
export const customErrorState = stateSelector("custom-error");
/**
 * Selector for the `danger` state.
 * @public
 */
export const dangerState = stateSelector("danger");
/**
 * Selector for the `dark-green` state.
 * @public
 */
export const darkGreenState = stateSelector("dark-green");
/**
 * Selector for the `dark-red` state.
 * @public
 */
export const darkRedState = stateSelector("dark-red");
/**
 * Selector for the `description` state.
 */
export const descriptionState = stateSelector("description");
/**
 * Selector for the `disabled` state.
 * @public
 */
export const disabledState = stateSelector("disabled");
/**
 * Selector for the `display-shadow` state.
 * @public
 */
export const displayShadowState = stateSelector("display-shadow");
/**
 * Selector for the `dot` state.
 * @public
 */
export const dotState = stateSelector("dot");
/**
 * Selector for the `end` state.
 * @public
 */
export const endState = stateSelector("end");
/**
 * Selector for the `error` state.
 * @public
 */
export const errorState = stateSelector("error");
/**
 * Selector for the `expanded` state.
 * @public
 */
export const expandedState = stateSelector("expanded");
/**
 * Selector for the `extra-large` state.
 * @public
 */
export const extraLargeState = stateSelector("extra-large");
/**
 * Selector for the `extra-small` state.
 * @public
 */
export const extraSmallState = stateSelector("extra-small");
/**
 * Selector for the `filled-darker` state.
 * @public
 */
export const filledDarkerState = stateSelector("filled-darker");
/**
 * Selector for the `filled-lighter` state.
 * @public
 */
export const filledLighterState = stateSelector("filled-lighter");
/**
 * Selector for the `fit-center` state.
 * @public
 */
export const fitCenterState = stateSelector("fit-center");
/**
 * Selector for the `fit-contain` state.
 * @public
 */
export const fitContainState = stateSelector("fit-contain");
/**
 * Selector for the `fit-cover` state.
 * @public
 */
export const fitCoverState = stateSelector("fit-cover");
/**
 * Selector for the `fit-none` state.
 * @public
 */
export const fitNoneState = stateSelector("fit-none");
/**
 * Selector for the `flip-block` state.
 * @public
 */
export const flipBlockState = stateSelector("flip-block");
/**
 * Selector for the `focus-visible` state.
 * @public
 */
export const focusVisibleState = stateSelector("focus-visible");
/**
 * Selector for the `forest` state.
 * @public
 */
export const forestState = stateSelector("forest");
/**
 * Selector for the `ghost` state.
 * @public
 */
export const ghostState = stateSelector("ghost");
/**
 * Selector for the `gold` state.
 * @public
 */
export const goldState = stateSelector("gold");
/**
 * Selector for the `grape` state.
 * @public
 */
export const grapeState = stateSelector("grape");
/**
 * Selector for the `has-message` state.
 * @public
 */
export const hasMessageState = stateSelector("has-message");
/**
 * Selector for the `huge` state.
 * @public
 */
export const hugeState = stateSelector("huge");
/**
 * Selector for the `icon` state.
 * @public
 */
export const iconOnlyState = stateSelector("icon");
/**
 * Selector for the `important` state.
 * @public
 */
export const importantState = stateSelector("important");
/**
 * Selector for the `indeterminate` state.
 * @public
 */
export const indeterminateState = stateSelector("indeterminate");
/**
 * Selector for the `informative` state.
 * @public
 */
export const informativeState = stateSelector("informative");
/**
 * Selector for the `inline` state.
 * @public
 */
export const inlineState = stateSelector("inline");
/**
 * Selector for the `inset` state.
 * @public
 */
export const insetState = stateSelector("inset");
/**
 * Selector for the `inverted` state.
 * @public
 */
export const invertedState = stateSelector("inverted");
/**
 * Selector for the `italic` state.
 * @public
 */
export const italicState = stateSelector("italic");
/**
 * Selector for the `justify` state.
 * @public
 */
export const justifyState = stateSelector("justify");
/**
 * Selector for the `large` state.
 * @public
 */
export const largeState = stateSelector("large");
/**
 * Selector for the `lavender` state.
 * @public
 */
export const lavenderState = stateSelector("lavender");
/**
 * Selector for the `light-teal` state.
 * @public
 */
export const lightTealState = stateSelector("light-teal");
/**
 * Selector for the `lilac` state.
 * @public
 */
export const lilacState = stateSelector("lilac");
/**
 * Selector for the `magenta` state.
 * @public
 */
export const magentaState = stateSelector("magenta");
/**
 * Selector for the `marigold` state.
 * @public
 */
export const marigoldState = stateSelector("marigold");
/**
 * Selector for the `medium` state.
 * @public
 */
export const mediumState = stateSelector("medium");
/**
 * Selector for the `mink` state.
 * @public
 */
export const minkState = stateSelector("mink");
/**
 * Selector for the `monospace` state.
 * @public
 */
export const monospaceState = stateSelector("monospace");
/**
 * Selector for the `multiline` state.
 * @public
 */
export const multiLineState = stateSelector("multiline");
/**
 * Selector for the `multiselect` state.
 * @public
 */
export const multipleState = stateSelector("multiple");
/**
 * Selector for the `navy` state.
 * @public
 */
export const navyState = stateSelector("navy");
/**
 * Selector for the `neutral` state.
 * @public
 */
export const neutralState = stateSelector("neutral");
/**
 * Selector for the `nowrap` state.
 * @public
 */
export const nowrapState = stateSelector("nowrap");
/**
 * Selector for the `numeric` state.
 * @public
 */
export const numericState = stateSelector("numeric");
/**
 * Selector for the `open` state.
 * @public
 */
export const openState = stateSelector("open");
/**
 * Selector for the `outline` state.
 * @public
 */
export const outlineState = stateSelector("outline");
/**
 * Selector for the `pattern-mismatch` state.
 * @public
 */
export const patternMismatchState = stateSelector("pattern-mismatch");
/**
 * Selector for the `peach` state.
 * @public
 */
export const peachState = stateSelector("peach");
/**
 * Selector for the `pink` state.
 * @public
 */
export const pinkState = stateSelector("pink");
/**
 * Selector for the `placeholder-shown` state.
 * @public
 */
export const placeholderShownState = stateSelector("placeholder-shown");
/**
 * Selector for the `platinum` state.
 * @public
 */
export const platinumState = stateSelector("platinum");
/**
 * Selector for the `plum` state.
 * @public
 */
export const plumState = stateSelector("plum");
/**
 * Selector for the `pressed` state.
 * @public
 */
export const pressedState = stateSelector("pressed");
/**
 * Selector for the `primary` state.
 * @public
 */
export const primaryState = stateSelector("primary");
/**
 * Selector for the `pumpkin` state.
 * @public
 */
export const pumpkinState = stateSelector("pumpkin");
/**
 * Selector for the `purple` state.
 * @public
 */
export const purpleState = stateSelector("purple");
/**
 * Selector for the `range-overflow` state.
 * @public
 */
export const rangeOverflowState = stateSelector("range-overflow");
/**
 * Selector for the `range-underflow` state.
 * @public
 */
export const rangeUnderflowState = stateSelector("range-underflow");
/**
 * Selector for the `red` state.
 * @public
 */
export const redState = stateSelector("red");
/**
 * Selector for the `resize-both` state.
 * @public
 */
export const resizeBothState = stateSelector("resize-both");
/**
 * Selector for the `resize-horizontal` state.
 * @public
 */
export const resizeHorizontalState = stateSelector("resize-horizontal");
/**
 * Selector for the `resize-vertical` state.
 * @public
 */
export const resizeVerticalState = stateSelector("resize-vertical");
/**
 * Selector for the `rounded` state.
 * @public
 */
export const roundedState = stateSelector("rounded");
/**
 * Selector for the `royal-blue` state.
 * @public
 */
export const royalBlueState = stateSelector("royal-blue");
/**
 * Selector for the `seafoam` state.
 * @public
 */
export const seafoamState = stateSelector("seafoam");
/**
 * Selector for the `selected` state.
 * @public
 */
export const selectedState = stateSelector("selected");
/**
 * Selector for the `semibold` state.
 * @public
 */
export const semiboldState = stateSelector("semibold");
/**
 * Selector for the `severe` state.
 * @public
 */
export const severeState = stateSelector("severe");
/**
 * Selector for the `shadow` state.
 * @public
 */
export const shadowState = stateSelector("shadow");
/**
 * Selector for the `size1000` state.
 * @public
 */
export const size1000State = stateSelector("size-1000");
/**
 * Selector for the `size100` state.
 * @public
 */
export const size100State = stateSelector("size-100");
/**
 * Selector for the `size200` state.
 * @public
 */
export const size200State = stateSelector("size-200");
/**
 * Selector for the `size400` state.
 * @public
 */
export const size400State = stateSelector("size-400");
/**
 * Selector for the `size500` state.
 * @public
 */
export const size500State = stateSelector("size-500");
/**
 * Selector for the `size600` state.
 * @public
 */
export const size600State = stateSelector("size-600");
/**
 * Selector for the `size700` state.
 * @public
 */
export const size700State = stateSelector("size-700");
/**
 * Selector for the `size800` state.
 * @public
 */
export const size800State = stateSelector("size-800");
/**
 * Selector for the `size900` state.
 * @public
 */
export const size900State = stateSelector("size-900");
/**
 * Selector for the `small` state.
 * @public
 */
export const smallState = stateSelector("small");
/**
 * Selector for the `square` state.
 * @public
 */
export const squareState = stateSelector("square");
/**
 * Selector for the `steel` state.
 * @public
 */
export const steelState = stateSelector("steel");
/**
 * Selector for the `step-mismatch` state.
 * @public
 */
export const stepMismatchState = stateSelector("step-mismatch");
/**
 * Selector for the `strikethrough` state.
 * @public
 */
export const strikethroughState = stateSelector("strikethrough");
/**
 * Selector for the `strong` state.
 * @public
 */
export const strongState = stateSelector("strong");
/**
 * Selector for the `submenu` state.
 * @public
 */
export const submenuState = stateSelector("submenu");
/**
 * Selector for the `subtle` state.
 * @public
 */
export const subtleState = stateSelector("subtle");
/**
 * Selector for the `success` state.
 * @public
 */
export const successState = stateSelector("success");
/**
 * Selector for the `teal` state.
 * @public
 */
export const tealState = stateSelector("teal");
/**
 * Selector for the `tint` state.
 * @public
 */
export const tintState = stateSelector("tint");
/**
 * Selector for the `tiny` state.
 * @public
 */
export const tinyState = stateSelector("tiny");
/**
 * Selector for the `too-long` state.
 * @public
 */
export const tooLongState = stateSelector("too-long");
/**
 * Selector for the `too-short` state.
 * @public
 */
export const tooShortState = stateSelector("too-short");
/**
 * Selector for the `transparent` state.
 * @public
 */
export const transparentState = stateSelector("transparent");
/**
 * Selector for the `truncate` state.
 * @public
 */
export const truncateState = stateSelector("truncate");
/**
 * Selector for the `type-mismatch` state.
 * @public
 */
export const typeMismatchState = stateSelector("type-mismatch");
/**
 * Selector for the `underline` state.
 * @public
 */
export const underlineState = stateSelector("underline");
/**
 * Selector for the `user-invalid` state.
 * @public
 */
export const userInvalidState = stateSelector("user-invalid");
/**
 * Selector for the `valid` state.
 * @public
 */
export const validState = stateSelector("valid");
/**
 * Selector for the `value-missing` state.
 * @public
 */
export const valueMissingState = stateSelector("value-missing");
/**
 * Selector for the `vertical` state.
 * @public
 */
export const verticalState = stateSelector("vertical");
/**
 * Selector for the `warning` state.
 * @public
 */
export const warningState = stateSelector("warning");
//# sourceMappingURL=states.js.map